import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["item", "intersect"];
import classnames from "classnames";
import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import { useRef, useCallback } from "react";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ChannelCard(props) {
  var item = props.item,
      intersect = props.intersect,
      props_ = _objectWithoutProperties(props, _excluded);

  var cardRef = useRef();
  var classNames = useSliderPosition(props_, cardRef);
  var handleClick = useCallback(function (e) {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    className: classnames(classNames, _defineProperty({}, styles.notAllowed, !item.isAllowedRating)),
    children: /*#__PURE__*/_jsx(Link, {
      href: routes.channelDetail(item.id),
      children: /*#__PURE__*/_jsx("a", {
        onClick: handleClick,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(CardArtwork, {
            item: item,
            intersect: intersect
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.infoContainer,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.info,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.title,
                children: /*#__PURE__*/_jsx("p", {
                  children: item.name
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "".concat(styles.feature, " ").concat(styles.info),
              children: props_.focusIndex != null && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.title,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.name
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.genre,
                  children: item.genres.map(function (genre) {
                    return genre.name;
                  }).join("/")
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.description,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.description
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.other,
                  children: [/*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx(FavoriteButton, {
                    metaId: item.id,
                    className: styles.favorite,
                    fillGray: true,
                    scale: true,
                    text: "\u304A\u6C17\u306B\u5165\u308A"
                  })]
                })]
              })
            })]
          })]
        })
      })
    })
  });
}